import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { deleteJob } from "../../../../actions/career.action";
import { userTypes } from "../../../../utils/helpers/constants";
import { useHistory } from "react-router-dom";
import { filterData } from "../../../../utils/helpers/dataHelper";
import CreateJobModal from "../../../../components/modals/admin/career/CreateJobModal";
import AntTable from "./AntTable";
import { AiOutlineArrowLeft } from "react-icons/ai";

export default function Body({ profile, jobs, jobDeleteStatusState }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [filterKey, setFilterKey] = useState("");

  const handleApproval = (item) => {
    var id = item.id;
    var action = item.approved ? "disapprove" : "approve";
    const payload = { id, action };
    // dispatch(getApproval(payload));
  };

  const handleView = (item) => {
    // history.push(`/dashboard/admin/announcement/${item.id}`);
  };

  const handleSearch = (value) => {
    setFilterKey(value);
  };

  const handleDelete = (item) => {
    console.log({ item });
    const id = item.id;
    const action = "delete";
    const payload = { id, action };

    dispatch(deleteJob(payload));
  };

  return (
    <div className="app-content hor-content">
      <div className="container mx-2 md:container md:mx-auto">
        <AiOutlineArrowLeft
          size={25}
          onClick={() => history.goBack()}
          className="mt-2 cursor-pointer"
        />
        {[profile["userType"]] === userTypes.ROLE_USER ? null : (
          <div className="page-header">
            <div>
              <h1 className="page-title">Career-Job</h1>
            </div>
          </div>
        )}
        <div className="p-2">
          <AntTable
            handleView={(item) => handleView(item)}
            handleSearch={(value) => handleSearch(value)}
            announcementList={filterData(jobs, filterKey, ["title"])}
            // statusState={announcementStatusLoading}
            // handleApproval={(item) => handleApproval(item)}
            handleDelete={(item) => handleDelete(item)}
            deleteStatusState={jobDeleteStatusState}
            handleCreate={() => setOpen(true)}
          />
        </div>
      </div>
      <CreateJobModal
        open={open}
        setOpen={setOpen}
        cancelButtonRef={cancelButtonRef}
      />
      {/* <EditAnnouncementModal
        item={announcement}
        open={editOpen}
        setOpen={setEditOpen}
        cancelButtonRef={cancelButtonRef}
      /> */}
    </div>
  );
}
